import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function lookupReducer(state = initialState.lookup, action) {
  switch (action.type) {
    case types.GET_POSTCODE_LOOKUP_SUCCESS:
      return {
        ...state,
        postcode: [...action.lookup],
      };
    case types.GET_ADDRESS_LOOKUP_SUCCESS:
      const {line_1 = '', line_2 = '', line_3 = ''} = action.lookup || {};
      let streetAddress = '';
      if (line_2) streetAddress += line_2 + ', ';
      streetAddress += line_1;
      if (line_3) streetAddress += `, ${line_3}`;

      return {
        ...state,
        address: action.lookup,
        streetAddress,
      };
    case types.RESET_POSTCODE_LOOKUP_REQUESTED:
      return null;
    default:
      return state;
  }
}
